import {
    IDataArray,
    DataArray
} from '../index';


export class FMIModel implements IDataArray {
    public Id = 0;
    public Name: string;

    public GetById(): number {
        return this.Id;
    }
}
